import { HTTP } from "../../../../services/api-service.js";
import commonObj from "../../../../services/common.js";
var common = new commonObj();
var baseUrl = common.baseURL;

const deliverySummaryStore = {
  namespaced: true,
  actions: {
    getDNSum({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/stock/DNSum", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    printDNSumByTime({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/stock/DNSumByTime", param, {
      responseType: 'blob',  // 设置为 blob 类型
    })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    printDNSumByDate({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/stock/DNSumByDate", param, {
      responseType: 'blob',  // 设置为 blob 类型
    })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
};
export default deliverySummaryStore;
